module.exports = __webpack_public_path__ + "static/media/edit.a989cc77.svg";